var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.0715 62.8989C99.8504 34.364 66.6755 16.1876 56.6013 11.4236C46.5271 6.65954 39.0885 8.88652 28.848 21.6654C18.6076 34.4442 20.0477 56.5179 19.8988 65.8221C19.7499 75.1263 37.3478 98.5676 72.0715 62.8989Z",
    fill: "#94DEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1673 16.1665H15.5007C14.1304 16.1665 12.8162 16.7108 11.8473 17.6798C10.8783 18.6487 10.334 19.9629 10.334 21.3332V62.6665C10.334 64.0368 10.8783 65.351 11.8473 66.3199C12.8162 67.2888 14.1304 67.8332 15.5007 67.8332H46.5006C47.8709 67.8332 49.1851 67.2888 50.154 66.3199C51.123 65.351 51.6673 64.0368 51.6673 62.6665V31.6665L36.1673 16.1665Z",
    stroke: "#0056CD",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.166 16.1665V31.6665H51.666",
    stroke: "#0056CD",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3327 44.5835H20.666",
    stroke: "#0056CD",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3327 54.9165H20.666",
    stroke: "#0056CD",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8327 34.25H23.2493H20.666",
    stroke: "#0056CD",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document-icon.9c8ce053.svg";
export { ForwardRef as ReactComponent };